import environment from 'platform/utilities/environment';
import footerContent from 'platform/forms/components/FormFooter';
import { externalServices } from 'platform/monitoring/DowntimeNotification';
import { minimalHeaderFormConfigOptions } from 'platform/forms-system/src/js/patterns/minimal-header';
import manifest from '../manifest.json';
import IntroductionPage from '../containers/IntroductionPage';
import ConfirmationPage from '../containers/ConfirmationPage';
import PreSubmitInfo from '../components/PreSubmitInfo';
import getHelp from '../../shared/components/GetFormHelp';
import transformForSubmit from './submit-transformer';
import veteranInformation from '../pages/veteranInformation';
import veteranInformationCont from '../pages/veteranInformationCont';
import claimantRelationship from '../pages/claimantRelationship';
import claimantInformation from '../pages/claimantInformation';
import claimantInformationCont from '../pages/claimantInformationCont';
import mailingAddress from '../pages/mailingAddress';
import requestedApportionmentPeople from '../pages/requestedApportionmentPeople';
import apportionmentReasonFlow from '../pages/apportionmentReasonFlow';
import remarks from '../pages/remarks';

import {
  claimantInformationText,
  claimantRelationshipText,
  formConfigText,
  formTitles,
  mailingAddressText,
  remarksText,
  veteranInformationText,
} from '../definitions/constants';

const formConfig = {
  rootUrl: manifest.rootUrl,
  urlPrefix: '/',
  submitUrl: `${environment.API_URL}/simple_forms_api/v1/simple_forms`,
  trackingPrefix: 'ss-0788-',
  defaultDefinitions: {},
  formOptions: {
    useWebComponentForNavigation: true,
  },
  dev: {
    collapsibleNavLinks: true,
    showNavLinks: true,
  },
  introduction: IntroductionPage,
  confirmation: ConfirmationPage,
  preSubmitInfo: {
    CustomComponent: PreSubmitInfo,
    statementOfTruth: {
      heading: formConfigText.statementOfTruthHeading,
      body: formConfigText.statementOfTruth,
      messageAriaDescribedby: formConfigText.statementOfTruth,
      fullNamePath: 'claimant.fullName',
    },
  },
  formId: '21-0788',
  version: 0,
  prefillEnabled: false,
  savedFormMessages: {},
  transformForSubmit,
  title: formTitles.form,
  subTitle: formTitles.subTitle,
  customText: {
    appType: formConfigText.appType,
    submitButtonText: formConfigText.submitButtonText,
    reviewPageTitle: formTitles.reviewAndSubmitStep,
    reviewPageFormTitle: formTitles.reviewAndSubmitPageTitle,
  },
  ...minimalHeaderFormConfigOptions({
    breadcrumbList: [
      { href: '/', label: 'VA.gov home' },
      { href: '/find-forms', label: 'VA forms' },
      {
        href: '/forms/21-0788',
        label: 'Application for apportionment of a beneficiary’s award',
      },
      {
        href: '/find-forms/about-form-21-0788',
        label: 'Apply for apportionment of a beneficiary’s award online',
      },
    ],
    wrapping: true,
  }),
  chapters: {
    veteranInformationChapter: {
      title: formTitles.veteranInformation,
      pages: {
        veteranInformationPage: {
          path: 'veteran-identification-information',
          title: veteranInformationText.pageTitle,
          uiSchema: veteranInformation.uiSchema,
          schema: veteranInformation.schema,
        },
        veteranInformationContPage: {
          path: 'veterans-identification-information',
          title: veteranInformationText.pageContTitle,
          uiSchema: veteranInformationCont.uiSchema,
          schema: veteranInformationCont.schema,
        },
      },
    },

    claimantInformationChapter: {
      title: formTitles.claimantInformation,
      pages: {
        claimantRelationshipPage: {
          path: 'your-relationship-to-the-veteran',
          title: claimantRelationshipText.pageTitle,
          uiSchema: claimantRelationship.uiSchema,
          schema: claimantRelationship.schema,
        },
        claimantInformationPage: {
          path: 'your-name',
          title: claimantInformationText.pageTitle,
          uiSchema: claimantInformation.uiSchema,
          schema: claimantInformation.schema,
        },
        claimantInformationContPage: {
          path: 'your-phone-number-and-email-address',
          title: claimantInformationText.pageTitleCont,
          uiSchema: claimantInformationCont.uiSchema,
          schema: claimantInformationCont.schema,
        },
        mailingAddressPage: {
          path: 'your-mailing-address',
          title: mailingAddressText.pageTitle,
          uiSchema: mailingAddress.uiSchema,
          schema: mailingAddress.schema,
        },
      },
    },

    apportionmentInformationChapter: {
      title: formTitles.apportionmentInformation,
      pages: {
        ...requestedApportionmentPeople,
      },
    },

    reasonsForClaimChapter: {
      title: formTitles.reasonsForClaim,
      pages: {
        ...apportionmentReasonFlow,
      },
    },

    remarksChapter: {
      title: formTitles.remarksInformation,
      pages: {
        remarksPage: {
          path: 'additional-information-about-your-claim',
          title: remarksText.pageTitle,
          uiSchema: remarks.uiSchema,
          schema: remarks.schema,
        },
      },
    },
  },
  downtime: {
    dependencies: [externalServices.lighthouseBenefitsIntake],
  },
  footerContent,
  getHelp,
};

export default formConfig;
